import { colors } from '@chegg-ui/theme';
export var CONFETTI_COUNT = 300;
var GRAVITY = 1;
var TERMINAL_VELOCITY = 5;
var DRAG = 0.075;
var COLORS = [{
  front: colors.orange500,
  back: colors.orange800
}, {
  front: colors.mint500,
  back: colors.mint900
}, {
  front: colors.sky300,
  back: colors.sky900
}, {
  front: colors.solar300,
  back: colors.solar500
}, {
  front: colors.cardinal500,
  back: colors.cardinal900
}, {
  front: colors.lavender300,
  back: colors.lavender700
}, {
  front: colors.violet400,
  back: colors.violet600
}, {
  front: colors.walnut300,
  back: colors.walnut700
}];
/**
 * Generate and return the randomly sized confetti bits size based on range passed
 */

export var randomRange = function randomRange(min, max) {
  return Math.random() * (max - min) + min;
};
/**
 * Generates an array of confetti to animate
 */

export var getConfetti = function getConfetti(canvas) {
  return new Array(CONFETTI_COUNT).fill(undefined).map(function () {
    return {
      color: COLORS[Math.floor(randomRange(0, COLORS.length))],
      dimensions: {
        x: randomRange(10, 20),
        y: randomRange(10, 30)
      },
      position: {
        x: randomRange(0, canvas.width),
        y: canvas.height - 1
      },
      rotation: randomRange(0, 2 * Math.PI),
      scale: {
        x: 1,
        y: 1
      },
      velocity: {
        x: randomRange(-25, 25),
        y: randomRange(0, -50)
      }
    };
  });
};
/**
 * Animates a single confetto on the canvas
 */

export var animateConfetto = function animateConfetto(canvas, context, confetto) {
  var width = confetto.dimensions.x * confetto.scale.x;
  var height = confetto.dimensions.y * confetto.scale.y; // Move canvas to position and rotate

  context.translate(confetto.position.x, confetto.position.y);
  context.rotate(confetto.rotation); // Apply forces to velocity

  confetto.velocity.x -= confetto.velocity.x * DRAG;
  confetto.velocity.y = Math.min(confetto.velocity.y + GRAVITY, TERMINAL_VELOCITY);
  confetto.velocity.x += Math.random() > 0.5 ? Math.random() : -Math.random(); // Set position

  confetto.position.x += confetto.velocity.x;
  confetto.position.y += confetto.velocity.y;

  if (confetto.position.y >= canvas.height) {
    return true; // delete confetto when out of frame
  } // Loop confetto x position


  if (confetto.position.x > canvas.width) confetto.position.x = 0;
  if (confetto.position.x < 0) confetto.position.x = canvas.width; // Spin confetto by scaling y

  confetto.scale.y = Math.cos(confetto.position.y * 0.03);
  context.fillStyle = confetto.scale.y > 0 ? confetto.color.front : confetto.color.back; // Draw confetto

  context.fillRect(-width / 2, -height / 2, width, height); // Reset transform matrix

  context.setTransform(1, 0, 0, 1, 0, 0);
  return false;
};

/**
 * Animates the confetti on the canvas
 */
export var animateConfetti = function animateConfetti(_ref) {
  var canvas = _ref.canvas,
      context = _ref.context,
      confetti = _ref.confetti,
      onAnimationEnd = _ref.onAnimationEnd;
  context.clearRect(0, 0, canvas.width, canvas.height);
  confetti.forEach(function (confetto, index) {
    var isOutOfFrame = animateConfetto(canvas, context, confetto);

    if (isOutOfFrame) {
      confetti.splice(index, 1);
    }
  });

  if (confetti.length === 0) {
    onAnimationEnd();
  }
  /* istanbul ignore next */


  window.requestAnimationFrame(function () {
    animateConfetti({
      canvas: canvas,
      context: context,
      confetti: confetti,
      onAnimationEnd: onAnimationEnd
    });
  });
};
/**
 * Sets the dimensions of the canvas
 */

var setCanvasDimensions = function setCanvasDimensions(canvas) {
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
};
/**
 * Renders confetti on the canvas
 */


export var renderConfetti = function renderConfetti(_ref2) {
  var canvasRef = _ref2.canvasRef,
      onAnimationStart = _ref2.onAnimationStart,
      onAnimationEnd = _ref2.onAnimationEnd;
  var canvas = canvasRef.current;
  var context = canvas === null || canvas === void 0 ? void 0 : canvas.getContext('2d');

  if (!canvas || !context) {
    return;
  }

  if (onAnimationStart) {
    onAnimationStart();
  }

  setCanvasDimensions(canvas);
  var confetti = getConfetti(canvas);
  animateConfetti({
    canvas: canvas,
    context: context,
    confetti: confetti,
    onAnimationEnd: onAnimationEnd
  });
};